import { ReportAllocatedAndSubsidies39Component } from "../../../components/SupportSystem/Reports/ReportAllocatedAndSubsidies39Component";
import { NavbarSupportSystem } from "../../../components/share/NavbarSupportSystem";
import { HeadTitle } from "../../../components/share/HeadTitle";
import { Footer } from "../../../components/share/Footer";
import { NewReportAllocatedAndSubsidies39Component } from "../../../components/SupportSystem/Reports/NewReportAllocatedAndSubsidies39Component";


export function ReportAllocatedAndSubsidies39Container() {
    const titleName = "ระบบการให้เงินช่วยเหลือหรืออุดหนุนกองทุนพัฒนาฝีมือแรงงาน";
    return(
        <div className="page-container bg-landing">
            <NavbarSupportSystem />
            <HeadTitle title={titleName} />
            <NewReportAllocatedAndSubsidies39Component/>
            <Footer />
        </div>   
        // 
    )
    
}